import React, { useState } from 'react';
import PageHeader from '../components/PageHeader';
import Blog from '../components/Blog';
import usePageMeta from '../utils/usePageMeta';
import { posts } from '../data/blog';

const categories = [...new Set(posts.map((post) => post.category))];

const BlogPage = () => {
  const [category, setCategory] = useState('');

  usePageMeta('Blog: Guides for Schools, Coaching Institutes & Colleges', 'Practical guides on school websites, admission marketing, ERP, smart classrooms, social media, content and career guidance for educational institutes.');

  return (
    <>
      <PageHeader
        eyebrow="Blog"
        title="Guides for schools, institutes and students."
        subtitle="Practical advice on admissions, websites, ERP, marketing, smart classrooms, content and careers."
      />
      <section className="section">
        <div className="container">
          <div className="blog-filters" role="group" aria-label="Filter articles by topic">
            <button
              type="button"
              className={`filter-chip ${category === '' ? 'active' : ''}`}
              aria-pressed={category === ''}
              onClick={() => setCategory('')}
            >
              All topics
            </button>
            {categories.map((item) => (
              <button
                key={item}
                type="button"
                className={`filter-chip ${category === item ? 'active' : ''}`}
                aria-pressed={category === item}
                onClick={() => setCategory(item)}
              >
                {item}
              </button>
            ))}
          </div>
          <Blog category={category} showAds />
        </div>
      </section>
    </>
  );
};

export default BlogPage;
